export function todayISODate() {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${now.getFullYear()}-${month}-${day}`;
}

export function formatBoardDate(dateString, today = todayISODate()) {
  if (!dateString) return "";
  const [year, month, day] = dateString.split("-").map(Number);
  const date = new Date(year, month - 1, day, 12, 0, 0);
  const options = { month: "short", day: "numeric" };
  if (year !== Number(today.slice(0, 4))) {
    options.year = "numeric";
  }
  return date.toLocaleDateString("en-US", options);
}

export function formatBoardMoney(amount) {
  if (amount == null || amount <= 0) return "";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

export function houseNames(tournament) {
  if (Array.isArray(tournament?.centers) && tournament.centers.length > 0) {
    return tournament.centers;
  }
  if (tournament?.center) {
    return [tournament.center];
  }
  return [];
}

export function houseLine(tournament) {
  const names = houseNames(tournament);
  if (names.length > 0) {
    return names.join(", ");
  }
  return tournament?.house || "";
}

const emptySeason = {
  season: [],
  upcoming: [],
  recent: [],
  live: null,
  next: null,
  completed: [],
  heroState: "off",
  boardTournament: null,
  boardRows: [],
  prizeFund: null,
  upcomingCount: 0,
};

function normalizeSeason(data, today) {
  return {
    ...emptySeason,
    today,
    ...data,
    season: data?.season ?? [],
    upcoming: data?.upcoming ?? [],
    recent: data?.recent ?? [],
    completed: data?.completed ?? [],
    boardRows: data?.boardRows ?? [],
    upcomingCount: data?.upcomingCount ?? 0,
  };
}

function isSeasonPayload(data) {
  return Boolean(data) && typeof data === "object" && !Array.isArray(data) && !data.error;
}

export async function fetchHomepageSeason(supabase) {
  const today = todayISODate();
  const { data, error } = await supabase
    .from("homepageSnapshot")
    .select("payload")
    .eq("id", 1)
    .maybeSingle();

  if (error) {
    throw error;
  }

  return normalizeSeason(isSeasonPayload(data?.payload) ? data.payload : null, today);
}

